"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Translator = void 0;
class Translator {
    constructor(data) {
        this.data = data;
    }
    getTranslations() {
        return this.data.translations || {};
    }
    setTranslations(translations) {
        this.data.translations = translations;
    }
    formattedMessage(transformer, id, values) {
        const message = this.resolvedMessage(id, values);
        return transformer.transform(message);
    }
    resolvedMessage(id, values) {
        var _a;
        const { config, resolvers, translations } = this.data;
        const { key } = id;
        let message = (_a = (translations && translations[key])) !== null && _a !== void 0 ? _a : config.onMissingMessage(id);
        if (message === undefined || message === key) {
            return key;
        }
        resolvers.forEach(resolver => {
            message = resolver.resolve(message, values);
        });
        return message;
    }
}
exports.Translator = Translator;
//# sourceMappingURL=translator.js.map